import { V4 } from '@moleculeone/utils';

import * as Drawing from '../const';
import { atomToNeighborsPairs } from '../selectors';
import { neighborsChiralityData, calcDepictedGeometry, chiralDeterminant } from '../isomerism';

export const ambiguousDetThreshold = 1 / 100;

export function chiralWarnings(mol, drawnMol) {
  const chiral = {};
  for (const bond of Object.values(mol.bonds)) {
    if (bond.type === Drawing.WEDGE || bond.type === Drawing.DASHED) {
      chiral[bond.start] = true;
    }
  }

  for (const atomIdx of Object.keys(chiral)) {
    const detData = neighborsChiralityData(mol, atomIdx, mol.positions);
    const det = chiralDeterminant(atomIdx, mol.positions[atomIdx], detData);
    if (det == null) {
      drawnMol.atoms[atomIdx].warnings.push("Can't interpret atom as chiral center");
    } else if (Math.abs(det) < ambiguousDetThreshold) {
      drawnMol.atoms[atomIdx].warnings.push('Chiral center configuration is ambiguous');
    }
  }
}

export function invisibleNodeWarnings(mol, drawnMol) {
  const allNeighbors = atomToNeighborsPairs(mol);
  for (const atom of Object.values(drawnMol.atoms)) {
    const atomNeighbors = allNeighbors[atom.idx];
    if (atom.center != null || atom.side != null || atomNeighbors.length !== 2) {
      continue;
    }
    const nbor1 = atomNeighbors[0];
    const nbor2 = atomNeighbors[1];
    if (nbor1[0].order !== 1 || nbor2[0].order !== 1 || nbor1[0].type != null || nbor2[0].type != null) {
      continue;
    }
    const atomPos = atom.pos;
    const nbor1Pos = V4.sub(drawnMol.atoms[nbor1[1].idx].pos, atomPos);
    const nbor2Pos = V4.sub(drawnMol.atoms[nbor2[1].idx].pos, atomPos);
    if (Math.abs(V4.angleZ(nbor1Pos, nbor2Pos)) > (Math.PI * 11) / 12) {
      atom.warnings.push('Hidden atom without label');
    }
  }
}

export function invalidValenceWarning(mol, drawnMol) {
  for (const atom of Object.values(drawnMol.atoms)) {
    if (atom.data.valence == null) {
      atom.warnings.push('Invalid valence');
    }
  }
}

export function wrongGeometryWarning(mol, drawnMol) {
  for (const bond of Object.values(mol.bonds)) {
    if (bond.geometry == null) {
      continue;
    }
    if (calcDepictedGeometry(mol, bond.idx) !== bond.geometry) {
      drawnMol.bonds[bond.idx].warnings.push('depicted geometry is different than actual one');
    }
  }
}

export function setWarnings(mol, drawnMol) {
  chiralWarnings(mol, drawnMol);
  invisibleNodeWarnings(mol, drawnMol);
  invalidValenceWarning(mol, drawnMol);
  wrongGeometryWarning(mol, drawnMol);
}
